import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "error"]

    change() {
        if (this.hasInputTarget) {
            this.inputTarget.classList.remove("input__danger")
        }

        if (this.hasErrorTarget) {
            this.errorTarget.remove()
        }
    }
}
